import React from 'react';
import { language } from '@Language';
import { observer } from 'mobx-react-lite';
import { ReactComponent as OopsNotFound } from './assets/oops-not-found.svg'
import { ReactComponent as OopsNotFoundTablet } from './assets/oops-not-found-tablet.svg'
import { ReactComponent as OopsNotFoundMobile } from './assets/oops-not-found-mobile.svg'
import './SomeThingWrongPageStyle.scss'
import { Button } from 'antd';
import { storeBowser } from '@Stores/StoreBowser';
import { useHistory } from 'react-router';
import storeGenealogy  from '@Stores/StoreGenealogy';

const SomeThingWrongPage = observer((props) => {

    const history = useHistory()
    
    return (
        <div className='something-wrong--wrapper container'>
            <div className='something-wrong--title'>{language.listen('somethingwrong_title')}</div>
            {(() => {
                if (storeBowser.isDesktop()) {
                    return <OopsNotFound />
                } else if (storeBowser.isTablet()) {
                    return <OopsNotFoundTablet />
                } else if (storeBowser.isMobile()) {
                    return <OopsNotFoundMobile />
                } else {
                    return <OopsNotFound />
                }
            })()}
            <div className='something-wrong--bottom'>
                <div className='something-wrong--message'>
                    {language.listen('somethingwrong_message')}
                </div>
                <div className='something-wrong--button'>
                    <Button className='button' style={{ width: '100%' }} size='small' type="primary" onClick={() => history.push('/menu')}>
                        {language.listen('somethingwrong_button')}
                    </Button>
                </div>
            </div>
            <div className="something-wrong--log">
                {/* {storeGenealogy.GetLogError() && <>{storeGenealogy.GetLogError().id}</>} */}
            </div>
        </div>
    );
})

export default SomeThingWrongPage;